type FadeState = 'none' | 'left' | 'right' | 'both';

export function observeModalTables(container: HTMLElement) {
  const cleanups: Array<() => void> = [];
  container.querySelectorAll('table').forEach((table) => {
    if (table.parentElement?.closest('table')) return;
    const scrollContainer = document.createElement('div');
    scrollContainer.className = 'sap__table-scroll';
    scrollContainer.tabIndex = 0;
    scrollContainer.setAttribute('role', 'region');
    scrollContainer.setAttribute('aria-label', 'Scrollable table');
    table.replaceWith(scrollContainer);
    scrollContainer.append(table);
    cleanups.push(observeTableOverflow(scrollContainer));
  });
  return () => cleanups.forEach((cleanup) => cleanup());
}

export function observeTableOverflow(
  element: HTMLElement,
  onChange?: (fade: FadeState) => void,
) {
  const update = () => {
    const overflow = element.scrollWidth - element.clientWidth;
    const atStart = element.scrollLeft <= 1;
    const atEnd = element.scrollLeft >= overflow - 1;
    const fade: FadeState =
      overflow <= 1 ? 'none' : atStart ? 'right' : atEnd ? 'left' : 'both';
    element.setAttribute('data-fade', fade);
    onChange?.(fade);
  };
  element.classList.add('sap__table-overflow');
  element.addEventListener('scroll', update, { passive: true });
  const observer = new ResizeObserver(update);
  observer.observe(element);
  element.querySelectorAll('table').forEach((table) => observer.observe(table));
  update();

  return () => {
    observer.disconnect();
    element.removeEventListener('scroll', update);
    element.removeAttribute('data-fade');
    element.classList.remove('sap__table-overflow');
  };
}
